import { useEffect, useState } from "react";
import { useSearchParams, Link, useLocation } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const loc = useLocation();
  const orderId = sp.get("order");
  const cancelled = loc.pathname.endsWith("cancel");
  const [status, setStatus] = useState(cancelled ? "cancelled" : "checking");

  useEffect(() => {
    if (cancelled || !orderId) return;
    let n = 0, stop = false;
    const poll = async () => {
      try {
        const { data } = loc.pathname.endsWith("paypal") && n === 0
          ? await api.post(`/orders/${orderId}/paypal-capture`) : await api.get(`/orders/${orderId}`);
        if (data.payment_status === "paid") return setStatus("paid");
      } catch { /* retry */ }
      if (++n < 15 && !stop) setTimeout(poll, 2000); else setStatus("pending");
    };
    poll();
    return () => { stop = true; };
  }, [orderId, cancelled, loc.pathname]);

  const view = {
    checking: [Loader2, "Confirming your payment...", "text-[#D99B26] animate-spin"],
    paid: [CheckCircle2, "Payment successful! Asante sana.", "text-[#1E5E3A]"],
    pending: [Loader2, "Payment still processing. Check My orders shortly.", "text-[#D99B26]"],
    cancelled: [XCircle, "Payment cancelled.", "text-red-600"],
  }[status];
  const [Icon, msg, cls] = view;
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-result-page">
      <Icon className={`w-16 h-16 mx-auto ${cls}`} />
      <h1 className="font-display text-3xl font-extrabold mt-6" data-testid="payment-result-status">{msg}</h1>
      {orderId && <p className="text-stone-500 mt-2">Order {orderId}</p>}
      <Link to="/orders" data-testid="payment-result-orders-link" className="inline-block mt-8 px-8 h-12 leading-[3rem] rounded-full bg-[#C85A32] text-white font-semibold">View my orders</Link>
    </div>
  );
}
